import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BankService } from 'src/app/pages/admin/services/bank.service';
import { CommonService } from '../services/common/common.service';
import { Router } from '@angular/router';
import { ApplicationTabEnum, ModuleEnum } from '../enum/general-enum';

@Component({
  selector: 'app-sharded-table',
  templateUrl: './sharded-table.component.html',
  styleUrls: ['./sharded-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ShardedTableComponent implements OnInit, OnChanges, OnDestroy {

  @Input() tableHeader: any = [];
  @Input() masterData: any;
  @Input() totalCount: any = 0;
  @Input() isMarketApp: boolean = false;
  @Output() drillDown: any = new EventEmitter();
  @Input() showDownloadBtn: boolean = false;
  @Input() downLoadUrl: string = ''
  @Output() pageChange: any = new EventEmitter();
  @Input() totalAmounts: any;
  @Output() onButtonClick: any = new EventEmitter();
  @Input() page: number = 1;
  @Output() view: any = new EventEmitter();
  @Output() downloadCsvList: any = new EventEmitter();
  @Input() showPaginator: boolean = true;
  @Input() showCsvList: boolean = false;
  @Input() backEvent: any = {};
  @Input() applicationTab!: ApplicationTabEnum;
  @Input() showAllState: boolean = true;
  @Input() moduleEnum!: ModuleEnum;

  // @Output() resetFilter: any = new EventEmitter();

  xtenantId: any;
  applicationType: any = [1, 2];
  openFilterModel: boolean = false;
  selectedTab: any;
  sNumberPage: number = 0;
  reportType: number = 1;
  paramFilter: any;
  censusEndPoint: string = ''
  @Input() isBack: boolean = false;
  receivedData: any;

  constructor(
    private bankService: BankService,
    private snackBar: MatSnackBar,
    private commonService: CommonService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
  }

  applicationListData: any = [];

  ngOnInit(): void {

    this.reportType = 1;
    this.commonService.resetData.subscribe((data) => {
      this.receivedData = data;
      this.reportType = this.receivedData?.reportType || 1;
      this.page = 1;
      this.sNumberPage = 0;
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['masterData']) {
      if (this.masterData) {
        this.applicationListData = [...this.masterData]; // Immutable assignment
      }
    }
  }
  // ngOnChanges(changes: SimpleChanges): void {
  //   console.log('ngOnChanges :' + this.applicationTab)
  //   console.log('masterData: ', this.masterData);
  //   // if (!this.masterData) {
  //   //   this.fetchPendingList();
  //   //   this.sNumberPage = 0;
  //   // } else {
  //   //   this.applicationListData = this.masterData;
  //   //   // this.sNumberPage = 0;
  //   //   // this.page = 1;
  //   // }

  //   // if (changes.backEvent) {
  //   //   this.reportType = this.backEvent?.reportType;
  //   // }
  // }
  ngAfterViewInit() {
    if (this.moduleEnum !== ModuleEnum.BankList
      && this.moduleEnum !== ModuleEnum.BranchList
      && this.moduleEnum !== ModuleEnum.UserList
      && this.moduleEnum !== ModuleEnum.UserLevelList
      && this.moduleEnum !== ModuleEnum.SHGWiseReportList
      && this.moduleEnum !== ModuleEnum.SHGWiseMarketList
      && this.moduleEnum !== ModuleEnum.BankLoanApplicationMarketList
      && this.moduleEnum !== ModuleEnum.BankLoanDisbursedMarketList
      && this.moduleEnum !== ModuleEnum.BankLoanPendingMarketList
      && this.moduleEnum !== ModuleEnum.GeoLoanApplicationMarketList
      && this.moduleEnum !== ModuleEnum.GeoLoanDisbursedMarketList
      && this.moduleEnum !== ModuleEnum.GeoLoanPendingMarketList
      && this.moduleEnum !== ModuleEnum.GeoLoanApplicationList
      && this.moduleEnum !== ModuleEnum.GeoLoanDisbursedList
      && this.moduleEnum !== ModuleEnum.GeoLoanPendingList
      && this.moduleEnum !== ModuleEnum.MarketWiseReportList

    ) {

      this.fetchPendingList();
    }
  }
  fetchPendingList() {
    let payload: any = {
      page: this.page,
      reportType: this.reportType,
      applicationTab: this.applicationTab
    }
    console.log(payload);
    this.bankService.getMarketState(payload).subscribe((res: any) => {
      if (res?.responseCode == 200) {
        if (this.showAllState && res?.wrapperList.length === 1)
          this.applicationListData = [];
        else if (this.showAllState && res?.wrapperList.length > 1)
          this.applicationListData = [...res?.wrapperList];
        else
          this.applicationListData = [...res?.wrapperList.filter((item: any) => item.stateCode !== '101')];
        this.totalCount = res?.totalCount;
        console.log(this.applicationListData);
        this.cdr.detectChanges();

      }
    }, ((error: any) => {
      this.applicationListData = [];
      this.totalCount = 0;
      this.openSnackBar('Bad Request', 'Close', true);
    }));
  }

  handleNextPage(event: any) {
    this.page = event;
    this.sNumberPage = event - 1;
    if (!this.masterData) {
      this.fetchPendingList();
      return;
    }
    this.pageChange.emit(this.page);
  }

  openSnackBar(message: any, action = '', isError: boolean = false) {
    this.snackBar.open(message, action, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: [
        isError ? 'error-snackbar' : 'success-snackbar',
        'centered-snackbar',
      ],
    });
  }

  viewData(item: any, type: string) {
    this.view.emit({ ...item, xtenantId: this.xtenantId });
  }

  downloadCsvButton() {
    this.commonService.getCsvData(this.downLoadUrl).subscribe((res) => {
      this.downloadCSV(res);
    })
  }

  openPdfView(data: any) {
    this.router.navigate([`/admin/loan/pdf/${data.shgLoanId}`])
  }

  downloadCSV(csvText: any) {
    let csvFileName = `SHG Loan Application List.csv`;
    const blob = new Blob([csvText], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = csvFileName;
    a.click();

    window.URL.revokeObjectURL(url);
  }

  action(item: any, i: number) {
    this.onButtonClick.emit({ item: item, index: i })
  }


  nestedDrill(event: any, item: any) {

    if (this.reportType <= 3) {
      this.reportType = this.reportType + 1;
    }

    let isDrill: boolean = false;
    let blockId: any = '';
    if (event?.key == 'stateName') {
      this.xtenantId = item['stateCode'];
    }
    if (this.isMarketApp && ['stateName', 'district_name', 'geoName'].includes(event?.key)) {
      isDrill = false;
    } else {
      blockId = item['id']
      isDrill = true;
    }

    this.drillDown.emit({
      isDrill: isDrill,
      xTenantId: this.xtenantId,
      navigate: item[event.key],
      key: event?.key,
      item: item,
      blockId: blockId,
      reportType: this.reportType
    });
    this.page = 1;
    this.sNumberPage = 0;
  }

  redirectDownloadCsvList() {
    this.downloadCsvList.emit({ redirect: true })
  }

  ngOnDestroy(): void {
    this.reportType = 1;
  }

}
